import React from "react";
import styles from "./projectdetailsheader.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { JikeiDebutBadgeSVG } from "../../assets/img/JikeiDebutBadgeSVG";
import ContentReportButton from "../../common/report/ContentReportButton";

type Props = {
  isJikei: boolean;
  title?: string;
  type?: string;
  color?: string;
  owner?: string;
  openModal: () => void;
};
export const ProjectDetailsHeader: React.FC<Props> = (props) => {
  const { isJikei, title, type, color, owner, openModal } = props;

  const type_style = {
    color: color ? `${color}` : "#D89529",
    border: color ? `1.5px solid ${color}` : `1.5px solid #D89529`,
    boxShadow: color ? `${color} 0 0 4px` : `#D89529 0 0 4px`,
  };

  return (
    <div className={styles["project-details_header"]}>
      <div className={styles["project-details_header_type-wrapper"]}>
        <span
          className={styles["project-details_header_type-text"]}
          style={type_style}
          data-testid="type_box"
        >
          {type}
        </span>
        <ContentReportButton handler={openModal} />
      </div>
      <h1 className={styles["project-details_header_title"]}>{title}</h1>
      <div className={styles["project-details_header_owner"]}>
        <FontAwesomeIcon icon={["fas", "user"]} />
        {/* TODO プロジェクト作成者の名前 */}
        <span>{owner}</span>
      </div>
      {isJikei ? (
        <div className={styles["project-details_header_jikeiBadge"]}>
          <JikeiDebutBadgeSVG />
        </div>
      ) : null}
    </div>
  );
};

export default ProjectDetailsHeader;
